import { Component } from '@angular/core';

@Component({
  selector: 'app-components-managecustomer-customer-users-priority',
  templateUrl: './customer-users-priority.component.html'
})
export class CustomerUsersPriorityComponent implements IActivatable {
  customer: Boo.Objects.Customer;
  user: Boo.Objects.User;
  partner: Boo.Objects.Partner;
  priorityViewApi: app.interfaces.IPriorityViewPublicApi;
  refreshCustomer: (callback?: () => void) => void;

  get noContactInfo(): boolean {
    return !this.customer.Users.some(x => x.CanContact);
  }

  activate?(params: any): JQueryPromise<void> {
    this.customer = params.customer;
    this.user = params.user;
    this.partner = params.partner;
    this.priorityViewApi = params.priorityViewApi;

    if (this.refreshCustomer) {
      this.refreshCustomer();
    }

    return $.Deferred<void>().resolve().promise();
  }

  close(): void {
    if (this.priorityViewApi) {
      this.priorityViewApi.resolve({ users: this.customer.Users });
    }
  }
}
